import React from "react"
import Button from "../../atoms/Button.atom"
import PropTypes from "prop-types"
import { chooseButtonClass } from "../../../utils/buttons.utils"
import { clsx } from "../../../utils/strings.utils"

export default function DangerButton({
  btnType = "regular",
  rounded = true,
  ...props
}) {
  return (
    <Button
      label={props.label}
      icon={props.icon}
      onClick={props.onClick}
      className={clsx(
        "p-button-danger",
        rounded && "border-round-3xl",
        chooseButtonClass(btnType)
      )}
      disabled={props.disabled}
      {...props}
    />
  )
}

DangerButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["regular", "text", "outlined"]),
  disabled: PropTypes.bool,
}
